import { useState, useRef, useEffect } from "react";
import { Play, Pause, Music2 } from "lucide-react";
import { toast } from "sonner";

const BARS = [12, 22, 16, 30, 24, 38, 20, 34, 26, 40, 18, 32, 24, 36, 16, 28, 22, 38, 14, 30, 26, 34, 18, 24, 12];

export const AudioPlayer = ({ title, src }) => {
  const [playing, setPlaying] = useState(false);
  const [progress, setProgress] = useState(0);
  const audioRef = useRef(null);

  useEffect(() => {
    if (!src) return;
    const a = audioRef.current;
    const onTime = () => setProgress(a.duration ? a.currentTime / a.duration : 0);
    const onEnd = () => setPlaying(false);
    a.addEventListener("timeupdate", onTime);
    a.addEventListener("ended", onEnd);
    return () => {
      a.removeEventListener("timeupdate", onTime);
      a.removeEventListener("ended", onEnd);
    };
  }, [src]);

  const toggle = () => {
    if (!src) {
      toast("Die Hörprobe wird bald verfügbar sein.", {
        description: "Der finale VisualMA Lernsong wird gerade produziert.",
      });
      return;
    }
    const a = audioRef.current;
    if (playing) a.pause();
    else a.play();
    setPlaying(!playing);
  };

  return (
    <div className="card-soft p-5 sm:p-6 flex items-center gap-4 sm:gap-5" data-testid="audio-player">
      {src && <audio ref={audioRef} src={src} preload="none" />}
      <button
        onClick={toggle}
        aria-label={playing ? "Pause" : "Abspielen"}
        data-testid="audio-play-button"
        className="shrink-0 w-14 h-14 sm:w-16 sm:h-16 rounded-full flex items-center justify-center text-white transition-transform duration-300 hover:scale-105 active:scale-95"
        style={{ background: "var(--terra)", boxShadow: "0 10px 24px rgba(200,90,50,0.32)" }}
      >
        {playing ? <Pause size={24} fill="currentColor" /> : <Play size={24} fill="currentColor" className="ml-1" />}
      </button>
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-2 mb-1.5">
          <Music2 size={14} style={{ color: "var(--terra)" }} />
          <p className="text-[11px] uppercase tracking-[0.18em] font-semibold text-[color:var(--ink-muted)]">
            Hörprobe
          </p>
        </div>
        <p className="font-medium text-sm sm:text-[15px] truncate mb-2.5">{title}</p>
        <div
          className={`flex items-end gap-[3px] h-8 text-[color:var(--terra)] ${playing ? "wave-live" : ""}`}
          data-testid="audio-waveform"
        >
          {BARS.map((h, i) => (
            <span
              key={i}
              className="wave-bar"
              style={{
                height: `${h}px`,
                opacity: src && i / BARS.length > progress ? 0.3 : playing ? 1 : 0.45,
                animationDelay: `${i * 0.06}s`,
              }}
            />
          ))}
        </div>
      </div>
    </div>
  );
};
